import './vendor';
import svg4everybody from 'svg4everybody';

import GalleryComponent from './components/gallery';
import NavComponent from './components/nav';
import MobileMenuComponent from './components/mobile-menu';
import HeaderComponent from './components/header';
import ScrollToTopComponent from './components/scroll-to-top';
import PhotoComponent from './components/photo';
import PopupComponent from './components/popup';
import SliderComponent from './components/slider';
import AjaxFormComponent from './components/ajax-form';
import CounterComponent from './components/counter';
import LazyIframeComponent from './components/lazy-iframe';
import PopupPromo from './components/popup-promo';
import PopupVariant from './components/popup-variant';

import HomeComponent from './components/home';
import AboutComponent from './components/about';
import MapComponent from './components/map';
import HistoryComponent from './components/history';
import SearchComponent from './components/search';
import PreviewsComponent from './components/previews';
import Rate from './components/rate';
import Vote from './components/vote';
import InputFile from './components/inputFile';
import InputSelect from './components/inputSelect';
import PartnersComponent from './components/partners';
import { HomeNew } from './components/home-new';
import { Faq } from './components/faq';
import { Disclaimer } from './components/disclaimer';
import { Objects } from './components/objects';
import { HistorySave } from './components/history-save';
import { AnimationsNew } from './lib/animations-new';
import { BigSlider } from './components/big-slider';
import { Past } from './components/past';
import { GalleryNew } from './components/gallery-new';
import { Press } from './components/press';
import { Media } from './components/media';
import { AboutNew } from './components/about-new';
import { ParkNew } from './components/park-new';
import { AlleyNew } from './components/alley-new';
import { NewsNew } from './components/news-new';
import { Calendar } from './components/calendar';
import { EventNew } from './components/event-new';
import { PageTimeline } from './components/page-timeline';


GalleryComponent.initAll();
NavComponent.initAll();
MobileMenuComponent.initAll();
HeaderComponent.initAll();
ScrollToTopComponent.initAll();
PhotoComponent.initAll();
PopupComponent.initAll();
SliderComponent.initAll();
AjaxFormComponent.initAll();
CounterComponent.initAll();
LazyIframeComponent.initAll();
PreviewsComponent.initAll();

HomeComponent.initAll();
AboutComponent.initAll();
HistoryComponent.initAll();
MapComponent.initAll();
SearchComponent.initAll();
Rate.initAll();
Vote.initAll();
InputFile.initAll('.js-file');
InputSelect.initAll('.js-select');
PartnersComponent();
HomeNew();
Faq()
Disclaimer();
Objects();
HistorySave();
BigSlider();
Past();
GalleryNew();
Press();
Media();
AboutNew();
ParkNew();
AlleyNew();
NewsNew();
Calendar();
EventNew();
PageTimeline();

svg4everybody();

PopupPromo.init('.js-popup--promo');
PopupVariant.initAll('.js-popup--variant');
PopupVariant.initAll('.js-popup--auth');

AnimationsNew();